import TechRelevance from "./TechRelevance";
import TechRelevanceV3 from "./TechRelevanceV3";
import TechRelevanceV4 from "./TechRelevanceV4";
import HomePage from "./Components/HomePage";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import AuthProvider from "./auth/AuthContext";
import CodeSnippetsShowcase from "./Components/CodeSnippetsShowcase";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ContactUs from "./pages/ContactUs";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import ProtectedRoute from "./Components/common/ProtectedRoute";
import SessionChecker from "./Components/common/SessionChecker";
import AppConfigLoader from "./Components/common/AppConfigLoader";

function App() {
  const NewTheme = useFeatureFlag("TechRelevance_New_Theme");
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          <AppConfigLoader />
          {/* <AuthProvider>{NewTheme ? <TechRelevanceV4 /> : <TechRelevanceV3 />}</AuthProvider> */}
          <AuthProvider>
            <SessionChecker />
              <Router>
              <Routes>
                <Route
                  path="/skill-relevance"
                  element={
                    <ProtectedRoute>
                      {NewTheme ? <TechRelevance /> : <TechRelevanceV3 />}
                    </ProtectedRoute>
                  }
                />
                <Route path="/" element={<HomePage />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/widget" element={<CodeSnippetsShowcase />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Router>
          </AuthProvider>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
